export default __webpack_public_path__ + "static/media/Animals_01.fe00e224.png";